<div class="flex flex-col align-middle relative items-center text-slate-900 hover:cursor-default">
    <button (click)="onExportDeckClicked()">
        <svg class="w-6 h-6 fill-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1">
            <title>Export</title>
            @if (isVisible) {
                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="closeSvgIcon" />
            } @else {
                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="exportSvgIcon" />
            }
        </svg>
    </button>
    @if (isVisible) {
        <div #dialog [formGroup]="exportDeckForm" class="absolute w-[350px] top-[34px] right-0 sm:right-[-6px]  bg-slate-100 z-30 shadow rounded-lg">
            <form class="flex flex-col gap-2 h-[250px] p-2">
                <div class="flex flex-row gap-1 items-center text-sm">
                    <div>Format:</div>
                    <select formControlName="format" class="bg-white ml-2 mr-2 p-1 grow rounded-sm shadow-sm">
                        @for (format of allFormats ; track format) {
                            @if (!$first) {
                                <option value="{{ format }}">{{ getFileFormatDisplayName(format) }}</option>
                            }
                        }
                    </select>
                </div>
                <textarea formControlName="content" rows="10" class="bg-slate-50 rounded shadow-sm p-2 text-xs font-mono text-nowrap text-slate-600"></textarea>
                <div class="flex flex-row gap-1 items-center justify-end text-sm">
                    <div class="flex flex-row gap-2 items-center grow">
                        <input formControlName="sideboard" type="checkbox" [ngClass]="{ 'hidden' : !canExportSideboard }"/>
                        <input type="checkbox" [disabled]="true" [ngClass]="{ 'hidden' : canExportSideboard }"/>
                        <div [ngClass]="{ 'text-slate-400' : !canExportSideboard }">Export Sideboard</div>
                    </div>
                    @if (!wasCopied) {
                        <button (click)="onCopyClicked()" class="flex flex-row gap-1 items-center bg-slate-50 w-[12ch] justify-center rounded shadow-sm p-1 pl-2 pr-2 border border-transparent hover:text-ponder-linkhover hover:stroke-ponder-linkhover hover:border-ponder-linkhover">
                            <svg class="w-5 h-5 fill-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1">
                                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="copySvgIcon" />
                            </svg>
                            <div>
                                Copy
                            </div>
                        </button>
                    } @else {
                        <div class="flex flex-row gap-1 items-center bg-slate-50 w-[12ch] justify-center text-slate-600 rounded shadow-sm p-1 pl-2 pr-2 border border-transparent">
                            Copied!
                        </div>
                    }
                </div>
            </form>
        </div>
    }
</div>